// Idempotency keys for state-changing calls (ARCHITECTURE.md §2a: every
// state-changing endpoint takes a caller-supplied idempotency_key).
//
// A key identifies one *user intent*, not one HTTP attempt: a form creates
// its key when it is first submitted and reuses it for every retry of that
// same submission (including the automatic retry after a step-up MFA
// prompt), so a timeout followed by "try again" can never double-submit a
// payout or refund. A new key is minted only when the user changes the
// request (different amount, different deposit) or explicitly starts over.

export function newIdempotencyKey(): string {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);
  bytes[6] = ((bytes[6] ?? 0) & 0x0f) | 0x40;
  bytes[8] = ((bytes[8] ?? 0) & 0x3f) | 0x80;
  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
